import React, { memo } from 'react';
const bonuses = [{
  title: 'BONUS 1 — KIT DE REGULACIÓN EMOCIONAL',
  tagline: 'Para acompañar emociones en el aula inclusiva.',
  image: 'https://cdn.magicpatterns.com/uploads/suiiA8Jz5dZUPHJJ8jGr3U/bonus_1.png',
  alt: 'Kit de Regulación Emocional',
  bullets: ['emociones', 'respiración', 'pausas activas', 'estrategias de calma']
}, {
  title: 'BONUS 2 — TABLEROS VISUALES Y APOYOS',
  tagline: 'Estructura visual para organizar el día.',
  image: 'https://cdn.magicpatterns.com/uploads/t9eMViaV1k62kiRwURcuMF/bonus_2.png',
  alt: 'Tableros Visuales y Apoyos',
  bullets: ['rutinas visuales', 'horarios adaptados', 'normas del aula', 'agenda visual']
}, {
  title: 'BONUS 3 — ATENCIÓN, MEMORIA Y FOCO',
  tagline: 'Para fortalecer funciones ejecutivas.',
  image: 'https://cdn.magicpatterns.com/uploads/nzt3WHyAXvDjvdhaHPomN8/bonus_3.png',
  alt: 'Atención, Memoria y Foco',
  bullets: ['atención visual', 'memoria secuencial', 'patrones', 'búsqueda visual']
}, {
  title: 'BONUS 4 — CUADERNO DE AUTONOMÍA',
  tagline: 'Independencia y organización personal.',
  image: 'https://cdn.magicpatterns.com/uploads/jU6FFWo55AEZnzuZHEs8Ua/bonus_4.png',
  alt: 'Cuaderno de Autonomía',
  bullets: ['rutinas del hogar', 'hábitos escolares', 'autocuidado', 'manejo del tiempo']
}, {
  title: 'BONUS 5 — PLANIFICADOR DOCENTE INCLUSIVO',
  tagline: 'Herramienta profesional para tu día a día.',
  image: 'https://cdn.magicpatterns.com/uploads/s31AyJbsvauz5ywT76Cfj2/bonus_5.png',
  alt: 'Planificador Docente Inclusivo',
  bullets: ['seguimiento del alumno', 'objetivos personalizados', 'planificación semanal', 'evaluación adaptada']
}];
const premium = {
  title: 'BONUS PREMIUM — JUEGOS PEDAGÓGICOS INCLUSIVOS',
  tagline: 'Aprender jugando. Visual y dinámico.',
  image: 'https://cdn.magicpatterns.com/uploads/iU8WJ3iUF2FF4L9rrsTVYm/bonus_6.png',
  alt: 'Juegos Pedagógicos Inclusivos',
  bullets: ['memotest y dominós', 'secuencias y lógica', 'recortables y tarjetas', 'juegos imprimibles']
};
export function BonusSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-32">
      <div className="max-w-5xl mx-auto" data-id="element-33">
        <div className="text-center mb-8" data-id="element-34">
          <h2 className="text-[20px] font-black mb-3 text-[#F9327E]" data-id="element-35">
            Además recibís 5 bonus + 1 bonus premium
          </h2>
          <div className="inline-block bg-red-600 text-white text-base md:text-lg font-black px-6 py-2 rounded-full shadow-lg animate-bounce" data-id="element-36">
            🎁 GRATIS POR HOY
          </div>
        </div>

        <div className="space-y-8" data-id="element-37">
          {bonuses.map((b, i) => <div key={i} className={`flex flex-col ${i % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-6 bg-gray-50 rounded-3xl p-6 border border-gray-200`} data-id="element-38">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-39">
                <img src={b.image} alt={b.alt} className="w-[340px] h-[340px] object-contain drop-shadow-xl" data-id="element-40" />
              </div>
              <div className="w-full md:w-1/2" data-id="element-41">
                <h3 className="text-2xl md:text-3xl font-black mb-2 text-blue-600" data-id="element-42">
                  🎁 {b.title}
                </h3>
                <p className="text-lg text-gray-700 mb-4" data-id="element-43">{b.tagline}</p>
                <ul className="grid grid-cols-2 gap-x-3 gap-y-1.5 text-base text-gray-800" data-id="element-44">
                  {b.bullets.map((item, idx) => <li key={idx} className="flex items-center" data-id="element-45">
                      <span className="text-green-600 mr-2 font-bold" data-id="element-46">✔</span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>)}

          {/* Premium */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-6 bg-yellow-50 rounded-3xl p-6 border-2 border-yellow-400 shadow-lg" data-id="element-47">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-48">
              <img src={premium.image} alt={premium.alt} className="w-[340px] h-[340px] object-contain drop-shadow-xl" data-id="element-49" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-50">
              <h3 className="text-2xl md:text-3xl font-black mb-2 text-yellow-600" data-id="element-51">
                👑 {premium.title}
              </h3>
              <p className="text-lg text-gray-700 mb-4" data-id="element-52">{premium.tagline}</p>
              <ul className="grid grid-cols-2 gap-x-3 gap-y-1.5 text-base text-gray-800" data-id="element-53">
                {premium.bullets.map((item, idx) => <li key={idx} className="flex items-center" data-id="element-54">
                    <span className="text-yellow-600 mr-2 font-bold" data-id="element-55">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}